import CheckboxTree from 'react-checkbox-tree';
import React from 'react';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import AllSelector from './AllSelector';
import noop from '../../../core/modules/common/tools/noop';

class CheckboxTreeSelector extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(previousProperties, previousState) {
    // eslint-disable-next-line react/no-find-dom-node
    const checkboxTreeSelectorDomNode = ReactDOM.findDOMNode(this);

    if (this.props.originalNodes && this.props.originalNodes.length > 0 && previousProperties !== this.props) {
      const selectedValues = this.props.selected;
      const liParentElements = checkboxTreeSelectorDomNode.querySelectorAll("li.rct-node.rct-node-parent");
      this.props.nodes.forEach((nodeShown) => {
        const nodeOriginal = this.props.originalNodes.find(node => node.value === nodeShown.value);
        if (nodeOriginal) {
          const nodeOriginalValues = nodeOriginal.children.map(originalNodeChild => originalNodeChild.value);
          const allSelected = nodeOriginalValues.every(val => selectedValues.indexOf(val) >= 0);
          const noneSelected = nodeOriginalValues.every(val => selectedValues.indexOf(val) === -1);
          const liElement = liParentElements[this.props.nodes.indexOf(nodeShown)];
          if (liElement) {
            if (allSelected) {
              const spanElementWithHalfCheck = liElement.querySelector("span.rct-icon-half-check");
              if (spanElementWithHalfCheck) {
                spanElementWithHalfCheck.classList.remove("rct-icon-half-check");
                spanElementWithHalfCheck.classList.add("rct-icon-check");
              }
            } else if (!noneSelected) {
              const spanElementWithHalfCheck = liElement.querySelector("span.rct-icon-half-check");
              if (!spanElementWithHalfCheck) {
                const spanElement = liElement.querySelector("span.rct-icon-check");
                if (spanElement) {
                  spanElement.classList.remove("rct-icon-check");
                  spanElement.classList.add("rct-icon-half-check");
                }
              }
            }
          }
        }
      });
    }
  }

  render() {
    const wrapperDivClassName = this.props.allSelectorDisabled && this.props.expandDisabled ? '' : 'selector-wrapper';
    const checkboxTreeDivClassName = this.props.allSelectorDisabled && this.props.expandDisabled ? '' : 'selector-list';
    return (
      <div className={wrapperDivClassName}>
        {!this.props.allSelectorDisabled &&
        <div className="selector-header">
          <h3 className="selector-title">{this.props.title}</h3>
          <AllSelector
            className="all-selector"
            onSelectAll={this.props.onSelectAll}
            onDeSelectAll={this.props.onDeSelectAll}
          />
        </div>
        }

        <div className={checkboxTreeDivClassName}>
          <CheckboxTree
            nodes={this.props.nodes}
            checked={this.props.selected}
            expanded={this.props.expanded}
            expandDisabled={this.props.expandDisabled}
            onCheck={this.props.onSelect}
            onExpand={this.props.onExpand}
            showNodeIcon={false}
          />
        </div>
      </div>

    );
  }
}

CheckboxTreeSelector.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  expanded: PropTypes.arrayOf(PropTypes.string),
  expandDisabled: PropTypes.bool,
  nodes: PropTypes.arrayOf(PropTypes.object),
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  onSelect: PropTypes.func,
  onExpand: PropTypes.func,
  allSelectorDisabled: PropTypes.bool,
  originalNodes: PropTypes.arrayOf(PropTypes.object),
};
CheckboxTreeSelector.defaultProps = {
  title: 'title',
  onSelectAll: noop,
  onDeSelectAll: noop,
  nodes: [],
  expanded: [],
  expandDisabled: false,
  selected: [],
  onSelect: noop,
  onExpand: noop,
  allSelectorDisabled: false,
  originalNodes: [],
};
export default CheckboxTreeSelector;
